/**
 * Returns true if all given keys are present in an object
 */
export const checkObjectTypeByKeys = <T>(object: any, keys: (keyof T)[]) => {
  return keys.every(key => object.hasOwnProperty(key));
};
